import { PropsWithChildren } from 'react';

type ExternalLinkProps = {
  to: string;
};
export default function ExternalLink({ to, children }: PropsWithChildren<ExternalLinkProps>) {
  return (
    <a href={to} target="_blank" rel="noreferrer" style={{ textDecorationLine: 'underline' }}>
      {children}
    </a>
  );
}
